import { render } from "./QuotaTables.vue?vue&type=template&id=3d2f4c8c&scoped=true"
import script from "./QuotaTables.vue?vue&type=script&lang=js"
export * from "./QuotaTables.vue?vue&type=script&lang=js"

import "./QuotaTables.vue?vue&type=style&index=0&id=3d2f4c8c&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d2f4c8c"]])

export default __exports__